import HoaDonMuaHangTrongNuocDocumentEntry from '@/features/mua-hang/hoa-don-mua-vao/hoa-don-mua-hang-trong-nuoc/DocumentEntry';
import HoaDonMuaDichVuDocumentEntry from '@/features/mua-hang/hoa-don-mua-vao/hoa-don-mua-dich-vu/DocumentEntry';
import type { PurchaseInvoiceReportDocumentEntryState } from '../utils/document-entry';

interface PurchaseInvoiceReportDocumentEntryProps {
  document: PurchaseInvoiceReportDocumentEntryState;
  onClose: () => void;
  onMutated?: () => void | Promise<void>;
}

export default function PurchaseInvoiceReportDocumentEntry({
  document,
  onClose,
  onMutated
}: PurchaseInvoiceReportDocumentEntryProps) {
  const entryProps = {
    document_uuid: document.documentUuid,
    document_type: document.documentType,
    formMode: 'view' as const,
    onClose,
    onMutated
  };

  switch (document.entryType) {
    case 'HOA_DON_MUA_HANG_TRONG_NUOC':
      return <HoaDonMuaHangTrongNuocDocumentEntry {...entryProps} />;
    case 'HOA_DON_MUA_DICH_VU':
      return <HoaDonMuaDichVuDocumentEntry {...entryProps} />;
    default:
      return null;
  }
}
